/*
 * Copyright (c) 2024-2026 Nodals AI Ltd
 * All rights reserved.
 */

const IAB_STANDARD_BANNER_SIZES: string[] = [
  '120x60', // Button 2
  '120x240', // Vertical Banner
  '120x600', // Skyscraper
  '160x600', // Wide Skyscraper
  '180x150', // Rectangle
  '200x200', // Small Square
  '234x60', // Half Banner
  '240x400', // Vertical Rectangle
  '250x250', // Square
  '300x50', // Mobile Banner
  '300x250', // Medium Rectangle
  '300x600', // Half Page
  '320x50', // Mobile Leaderboard
  '320x100', // Large Mobile Banner
  '336x280', // Large Rectangle
  '468x60', // Banner
  '728x90', // Leaderboard
  '970x90', // Large Leaderboard
  '970x250', // Billboard
];

const DIMENSIONS_UNKNOWN = '-1x-1';

// Pseudo-size token in the placement.sizes fact for placements that accept
// native creatives (prebid native mediaType, or a GPT slot declaring 'fluid'
// or 1x1). Native has no width/height, so without this token native-capable
// placements are invisible to size-based targeting rules.
const NATIVE_SIZE_TOKEN = 'native';

// Video viewable impression: continuous in-view playback required before dispatch
const VIEWABLE_IMPRESSION_PLAYBACK_MS = 2000;
const VIEWABILITY_CHECK_INTERVAL_MS = 500;

enum Visibility {
  UNKNOWN = -1,
  NOT_VISIBLE = 0,
  VISIBLE = 1,
}

enum PlacementType {
  DISPLAY = 'd',
  VIDEO = 'v',
  ADVERTORIAL = 'a',
}

export {
  DIMENSIONS_UNKNOWN,
  IAB_STANDARD_BANNER_SIZES,
  NATIVE_SIZE_TOKEN,
  PlacementType,
  VIEWABILITY_CHECK_INTERVAL_MS,
  VIEWABLE_IMPRESSION_PLAYBACK_MS,
  Visibility,
};
